export default __webpack_public_path__ + "static/media/dimg5.8d3602b1.jpg";